import type { Theme } from '../../types'
import { ProductLine } from '@adc/constants'

export const getThemedCompact = (theme?: Theme | null, compact?: boolean) => {
  if (typeof compact === 'undefined') {
    if (theme?.productLine === ProductLine.Morpheus) {
      return true
    }
  }
  return compact
}
